import React, { useEffect } from 'react';
import { TextReveal } from '../components/TextReveal';
import { SubpageHeader } from '../components/SubpageHeader';
import { CTA } from '../components/CTA';
import { SEO } from '../components/SEO';
export function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <SEO title="Impressum – PP Management & Consulting" description="Impressum der PP Immobilien & Managment GmbH. Angaben gemäß § 5 DDG. Geschäftsführer: Philip Michael Steinke. Sitz: Berlin." canonical="https://ppimpact.com/impressum" noindex data-id="element-287" />
      <SubpageHeader data-id="element-288" />
      <main className="pt-40 pb-24 md:pt-56 md:pb-32 min-h-screen" data-id="element-289">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-290">
          <div className="mb-16 md:mb-24" data-id="element-291">
            <TextReveal text="IMPRESSUM" as="h1" className="text-[clamp(3rem,6vw,6rem)] font-black leading-[0.9] tracking-tighter text-white mb-4" data-id="element-292" />
          </div>

          <div className="space-y-12 text-muted text-lg leading-relaxed" data-id="element-293">
            <section data-id="element-294">
              <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-295">
                Angaben gemäß § 5 DDG
              </h2>
              <p data-id="element-296">PP Immobilien & Managment GmbH</p>
              <p data-id="element-297">Grüner Weg 59A 12359 Berlin</p>
              <p data-id="element-298">Handelsregister: HRB 218746 B</p>
              <p data-id="element-299">Registergericht: Amtsgericht Charlottenburg (Berlin)</p>
              <p className="mt-4" data-id="element-300">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz: DE123456789
              </p>
            </section>

            <section data-id="element-301">
              <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-302">
                Vertreten durch
              </h2>
              <p data-id="element-303">
                den geschäftsführenden Gesellschafter: Philip Michael Steinke
              </p>
            </section>

            <section data-id="element-304">
              <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-305">
                Kontakt
              </h2>
              <p data-id="element-306">Telefon: +49 15114796710</p>
              <p data-id="element-307">E-Mail: info@ppimpact.com</p>
            </section>

            <div className="h-px w-full bg-white/10 my-12" data-id="element-308" />

            <section data-id="element-309">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-310">
                Rechtliche Hinweise (Disclaimer)
              </h2>

              <div className="space-y-8" data-id="element-311">
                <div data-id="element-312">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-313">
                    Inhalte der Website
                  </h3>
                  <p data-id="element-314">
                    Die Inhalte dieses Webauftritts werden mit größtmöglicher
                    Sorgfalt erstellt. Die PP Immobilien & Managment GmbH
                    übernimmt jedoch keine Gewähr für die Richtigkeit,
                    Vollständigkeit und Aktualität der bereitgestellten Inhalte.
                  </p>
                </div>

                <div data-id="element-315">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-316">
                    Verfügbarkeit der Website
                  </h3>
                  <p data-id="element-317">
                    PP Immobilien & Managment GmbH ist bestrebt, den Dienst
                    unterbrechungsfrei zum Abruf anzubieten. Auch bei aller
                    Sorgfalt können aber Ausfallzeiten nicht ausgeschlossen
                    werden. Die PP Immobilien & Managment GmbH behält sich das
                    Recht vor, ihr Angebot jederzeit zu ändern oder
                    einzustellen. Für durch nicht fehlerfrei angelegte Dateien
                    oder nicht fehlerfrei strukturierte Formate bedingte
                    Unterbrechungen oder anderweitige Störungen übernimmt sie
                    keine Gewähr.
                  </p>
                </div>

                <div data-id="element-318">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-319">
                    Streitschlichtung
                  </h3>
                  <p data-id="element-320">
                    Wir sind nicht verpflichtet, an Streitbeilegungsverfahren
                    vor einer Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>

                <div data-id="element-321">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-322">
                    Hinweis zur Haftung für Inhalte
                  </h3>
                  <p className="mb-4" data-id="element-323">
                    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
                    Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                    verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
                    Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                    gespeicherte fremde Informationen zu überwachen oder nach
                    Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                    hindeuten.
                  </p>
                  <p data-id="element-324">
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                    Informationen nach den allgemeinen Gesetzen bleiben hiervon
                    unberührt. Eine diesbezügliche Haftung ist jedoch erst ab
                    dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                    möglich. Sobald uns entsprechende Rechtsverletzungen bekannt
                    werden, entfernen wir diese Inhalte umgehend.
                  </p>
                </div>

                <div data-id="element-325">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-326">
                    Hinweis zur Verwendung externer Links und Frames
                  </h3>
                  <p className="mb-4" data-id="element-327">
                    Die PP Immobilien & Managment GmbH ist für die eigenen
                    Inhalte, die sie zur Nutzung bereithält, nach den
                    allgemeinen Gesetzen verantwortlich. Von diesen eigenen
                    Inhalten sind Querverweise (Links und Frames) auf die von
                    anderen Anbieter:innen bereitgehaltenen Inhalte zu
                    unterscheiden. Durch den Querverweis hält die PP Immobilien
                    & Managment GmbH insofern fremde Inhalte zu externen
                    Websites Dritter zur Nutzung bereit, die als Link oder Frame
                    gekennzeichnet sind und auf deren Inhalte die PP Immobilien
                    & Managment GmbH keinen Einfluss hat.
                  </p>
                  <p data-id="element-328">
                    Bei Links und Frames handelt es sich um dynamische
                    Verweisungen. Deshalb können wir für diese fremden Inhalte
                    auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
                    Seiten ist stets der jeweilige Anbieter/Betreiber der
                    Webseiten verantwortlich. Die PP Immobilien & Managment GmbH
                    hat bei der erstmaligen Verknüpfung zwar den fremden Inhalt
                    daraufhin überprüft, ob durch ihn eine mögliche
                    zivilrechtliche oder strafrechtliche Verantwortlichkeit
                    ausgelöst wird. Eine permanente inhaltliche Kontrolle der
                    verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
                    einer Rechtsverletzung nicht zumutbar. Wenn die PP
                    Immobilien & Managment GmbH feststellt oder von anderen
                    darauf hingewiesen wird, dass ein konkretes Angebot, zu dem
                    sie einen Link oder Frame bereitgestellt hat, eine zivil-
                    oder strafrechtliche Verantwortlichkeit auslöst, wird sie
                    den Verweis auf dieses Angebot aufheben.
                  </p>
                </div>

                <div data-id="element-329">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-330">
                    Hinweis zum Urheberrecht
                  </h3>
                  <p className="mb-4" data-id="element-331">
                    Alle Inhalte und Strukturen dieser Website sind urheber- und
                    leistungsschutzrechtlich geschützt. Die Veröffentlichung im
                    World Wide Web oder in anderen Internet-Diensten bedeutet
                    noch keine Einverständniserklärung für eine anderweitige
                    Nutzung durch Dritte. Jede vom deutschen Urheberrecht nicht
                    zugelassene Verwertung bedarf der vorherigen schriftlichen
                    Zustimmung der PP Immobilien & Managment GmbH oder des
                    jeweiligen Autors bzw. Erstellers. Die durch die PP
                    Immobilien & Managment GmbH erstellten Inhalte und Werke
                    unterliegen dem deutschen Urheberrecht. Downloads und Kopien
                    dieser Seite sind nur für den privaten, nicht kommerziellen
                    Gebrauch gestattet.
                  </p>
                  <p data-id="element-332">
                    Soweit die Inhalte auf dieser Seite nicht vom Betreiber
                    erstellt wurden, werden die Urheberrechte Dritter beachtet
                    und solche Inhalte entsprechend gekennzeichnet. Sollten Sie
                    trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                    bitten wir um einen entsprechenden Hinweis. Bei
                    Bekanntwerden von Rechtsverletzungen werden wir derartige
                    Inhalte umgehend entfernen.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
        <CTA data-id="element-333" />
      </main>
    </>;
}